export const mobileNumberRegex = /^\d{10,15}$/;
export const ukMobileNumberRegex = /^07\d{9}$/;
export const extendedUKMobileNumberRegex = /^(\+44|0)7\d{9}$/;
export const pacCodeRegex = /^[A-Za-z]{3}\d{6}$/;
